export function attachListener(selector, hook, func) {
    let els;
    if (typeof selector === 'string') {
        els = document.querySelectorAll(selector);
    } else {
        // Allow elements to be passed in directly.
        if (selector && selector.length === undefined) {
            els = [selector];
        } else {
            els = selector;
        }
    }
    Array.prototype.forEach.call(els, function(el) {
        el.addEventListener(hook, func);
    });
}

export function getCookie(sName) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + sName + "=");
    if (parts.length == 2) {
        return parts
            .pop()
            .split(";")
            .shift();
    } else {
        return null;
    }
}

export function setCookie(sName, sVal, expireMinutes = 1440) {
    var d = new Date(),
        CurrentCookie = getCookie(sName);
    if (CurrentCookie === null || CurrentCookie !== sVal) {
        d.setTime(d.getTime() + expireMinutes * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = sName + "=" + sVal + ";" + expires + ";path=/";
    }
}

export function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

export function sanitizeAndEncodeQuery(query) {
    let newQuery = query.replace(/[\u201C\u201D]/g, '"').replace(/[\u2018\u2019]/g, "'");
    return encodeURIComponent(newQuery);
}

export function readableSanitize(unsafe) {
    return unsafe
        .replace(/\x2a/g, " ") .replace(/%22/g, " ").replace(/%21/g, "!").replace(/%40/g, "@").replace(/%23/g, "#").replace(/%29/g, ")").replace(/%28/g, "(").replace(/%26/g, "&").replace(/%5E/g, " ").replace(/%24/g, " ").replace(/%2B/g, " ").replace(/%5C/g, " ").replace(/%25/g, "%").replace(/%27/g, " ").replace(/%3A/g, " ").replace(/%3C/g, " ").replace(/%3F/g, "?").replace(/%7D/g, " ").replace(/%3E/g, " ").replace(/%7E/g, " ").replace(/%3B/g, " ").replace(/%2F/g, " ").replace(/%7C/g, " ").replace(/%7B/g, " ").replace(/%5B/g, "[").replace(/%5D/g, "]").replace(/%3D/g, " ").replace(/%2C/g, ",").replace(/%E2/g, " ").replace(/%80/g, " ").replace(/%99/g, " ").replace(/%98/g, " ").replace(/\+/g, " ");
}

export function xhrJson(method, url, contentType, payload, callback, responseRequired = true, passRequest = false) {
    const request = new XMLHttpRequest();
    request.open(method, url, true);
    request.setRequestHeader("Content-Type", contentType);
    request.onreadystatechange = function (res) {
        if (this.readyState == 4) {
            if (responseRequired) {
                try {
                    const data = JSON.parse(res.target.response);
                    if (passRequest) {
                        callback(data, request);
                    } else {
                        callback(data);
                    }
                } catch (e) {
                    console.log(e);
                }
            } else {
                callback(res.target.response);
            }
        }
    };
    request.send(payload);
}

export function getExcludeSites() {
    return ['!lca', '!wp-library', '!standingforfreedom'];
}